import * as global from './GlobalSelectors';
import * as general from './GeneralSelectors';
import * as flights from './FlightsSelectors';
import * as devAuth from './DevAuthSelectors';
import * as routes from './RoutesSelectors';
import * as allFlights from './AllFlightsSelectors';
import * as passenger from './PassengerSelectors';
import * as passengers from './PassengersSelectors';
import * as meals from './MealsSelectors';
import * as relationshipTypes from './RelationshipTypesSelectors';
import * as terms from './TermsSelectors';
import * as navigation from './NavigationSelectors';

export default {
  global,
  general,
  flights,
  devAuth,
  routes,
  allFlights,
  passenger,
  passengers,
  meals,
  relationshipTypes,
  terms,
  navigation,
};



// WEBPACK FOOTER //
// ./src/redux/selectors/Index.js